// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__m2tSf","title":"InfoRow_title__PYTv4"};